// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { personaTourModules } from '../constants/persona-destinations.js';
export { accessAccountabilityTour } from './access-accountability.js';
export { assessmentsTour } from './assessments.js';
export { auditTrailTour } from './audit-trail.js';
export { classificationTour } from './classification.js';
export { complianceFormsTour } from './compliance-forms.js';
export { connectorsTour } from './connectors.js';
export { consentPropertiesTour } from './consent-properties.js';
export { consentTour } from './consent.js';
export { forsetiTour } from './forseti.js';
export { dashboardTour } from './dashboard.js';
export { dataMappingTour } from './data-mapping.js';
export { dataSubjectsTour } from './data-subjects.js';
export { deletionOrchestrationTour } from './deletion-orchestration.js';
export { discoveryTour } from './discovery.js';
export { governanceTour } from './governance.js';
export { helpCenterTour } from './help-center.js';
export { incidentOpsTour } from './incident-ops.js';
export { incidentsTour } from './incidents.js';
export { localizationTour } from './localization.js';
export { monitoringTour } from './monitoring.js';
export { onboardingTour } from './onboarding.js';
export { organizationsTour } from './organizations.js';
export { partnerWorkspaceTour } from './partner-workspace.js';
export { platformSettingsTour } from './platform-settings.js';
export { privacyScannerTour } from './privacy-scanner.js';
export { programGovernanceTour } from './program-governance.js';
export { rightsRequestsTour } from './rights-requests.js';
export { sectorOverlaysTour } from './sector-overlays.js';
export { taskManagementTour } from './task-management.js';
export { vendorRiskTour } from './vendor-risk.js';
// Lazy imports for the ALL_TOUR_SCRIPTS array
import { accessAccountabilityTour } from './access-accountability.js';
import { assessmentsTour } from './assessments.js';
import { auditTrailTour } from './audit-trail.js';
import { classificationTour } from './classification.js';
import { complianceFormsTour } from './compliance-forms.js';
import { connectorsTour } from './connectors.js';
import { consentPropertiesTour } from './consent-properties.js';
import { consentTour } from './consent.js';
import { forsetiTour } from './forseti.js';
import { dashboardTour } from './dashboard.js';
import { dataMappingTour } from './data-mapping.js';
import { dataSubjectsTour } from './data-subjects.js';
import { deletionOrchestrationTour } from './deletion-orchestration.js';
import { discoveryTour } from './discovery.js';
import { governanceTour } from './governance.js';
import { helpCenterTour } from './help-center.js';
import { incidentOpsTour } from './incident-ops.js';
import { incidentsTour } from './incidents.js';
import { localizationTour } from './localization.js';
import { monitoringTour } from './monitoring.js';
import { onboardingTour } from './onboarding.js';
import { organizationsTour } from './organizations.js';
import { partnerWorkspaceTour } from './partner-workspace.js';
import { platformSettingsTour } from './platform-settings.js';
import { privacyScannerTour } from './privacy-scanner.js';
import { programGovernanceTour } from './program-governance.js';
import { rightsRequestsTour } from './rights-requests.js';
import { sectorOverlaysTour } from './sector-overlays.js';
import { taskManagementTour } from './task-management.js';
import { vendorRiskTour } from './vendor-risk.js';
/** Tour scripts in display order. */
export const ALL_TOUR_SCRIPTS = [
    dashboardTour,
    forsetiTour,
    rightsRequestsTour,
    dataMappingTour,
    dataSubjectsTour,
    governanceTour,
    consentTour,
    assessmentsTour,
    incidentsTour,
    classificationTour,
    monitoringTour,
    localizationTour,
    // Module 30 (owner ruling OR-26), beside Localization in the sidebar's category.
    sectorOverlaysTour,
    complianceFormsTour,
    taskManagementTour,
    auditTrailTour,
    incidentOpsTour,
    vendorRiskTour,
    deletionOrchestrationTour,
    discoveryTour,
    connectorsTour,
    consentPropertiesTour,
    programGovernanceTour,
    accessAccountabilityTour,
    privacyScannerTour,
    organizationsTour,
    partnerWorkspaceTour,
    platformSettingsTour,
    onboardingTour,
    helpCenterTour,
];
/**
 * Sprint 63.43.0 gate E12.5 pass 1 (P2-1) — the modules that have a shipped
 * tour script, derived from `ALL_TOUR_SCRIPTS` and never listed by hand. An
 * offer of a tour (Persona Paths, onboarding progress) reads this, so a module
 * gains its tour the moment its script is added here and is never offered one
 * before: 63.43.0 moved destinations into `sector_overlays` before its script
 * existed, and the persona detail offered a "Sector Overlays Tour" whose Start
 * could only fail. Sprint 63.44.0 added that script, so those destinations now
 * offer it.
 */
export const TOUR_SCRIPT_MODULES = new Set(ALL_TOUR_SCRIPTS.map((s) => s.module));
/** Whether `module` has a shipped tour script. */
export function hasTourScript(module) {
    return TOUR_SCRIPT_MODULES.has(module);
}
/**
 * The tours a persona is offered: `personaTourModules` (its destinations'
 * modules, in order, each once) restricted to modules with a tour script.
 * `personaTourModules` itself stays unfiltered — help articles follow every
 * destination module, toured or not.
 */
export function personaTourScriptModules(entry) {
    return personaTourModules(entry).filter(hasTourScript);
}
//# sourceMappingURL=index.js.map